<template>
  <article class="pf-pillar">
    <i :class="pillar.icon" class="pf-pillar__icon" aria-hidden="true" />
    <h3 class="pf-pillar__title">{{ pillar.title }}</h3>
    <p class="pf-pillar__summary">{{ pillar.summary }}</p>
  </article>
</template>

<script>
export default {
  name: "PathfinderPillarCard",
  props: {
    pillar: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.pf-pillar {
  background: var(--background-color2);
  padding: clamp(24px, 4vw, 35px) clamp(18px, 3vw, 25px);
  border-radius: 18px;
  text-align: center;
  height: 100%;
  border: 1px solid var(--border-color-hover1, #e5e7eb);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.06);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.pf-pillar:hover {
  transform: translateY(-8px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.12);
}

.pf-pillar__icon {
  display: block;
  font-size: 2.2rem;
  color: var(--border-color-hover);
  margin-bottom: 15px;
}

.pf-pillar__title {
  margin: 0 0 10px;
  font-size: 1.2rem;
  font-weight: 700;
  color: var(--text-color1);
}

.pf-pillar__summary {
  margin: 0;
  font-size: 0.95rem;
  line-height: 1.55;
  color: var(--text-color1);
  opacity: 0.8;
}
</style>
